import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AwareHttpRequest, AwareHttpRequestModule, AwareHttpService } from '@appbolaget/aware-http';
import * as moment from 'moment';
import { Post, Notification, File, Unit } from '@appbolaget/aware-model';
import { ModelService } from '@viewservices';
import { WeekPost } from '@models';
import { Store } from '@ngxs/store';
import { UnitState } from 'app/state/unit.state';
import { FileBridgeLocalFile } from '@components/media/components';
import { environment } from '@env';

@Injectable()
export class PostService extends ModelService<Post> {
    activePost: Post;
    model: Post = new Post();

    post: BehaviorSubject<Post> = new BehaviorSubject<Post>(null);
    post$ = this.post.asObservable();

    constructor(
        protected api: AwareHttpService,
        private store: Store,
    ) {
        super(api);
    }

    // autocomplete(filter: any = false, options: any = {}) {
    //     filter.sort = this.model.sorting;

    //     const filterString = this.model.buildFilterQuery(filter);
    //     const url = this.model.endpoint;

    //     let params = {
    //         filter: filterString,
    //     };

    //     if (options) {
    //         params = Object.assign({}, params, options);
    //     }

    //     return this.api
    //         .get(url)
    //         .parameters(params)
    //         .header('language', this.languageService.activeApiLanguage)
    //         .execute()
    //         .pipe(
    //             map((res) => {
    //                 const data: any = [];

    //                 for (const obj of res['data']) {
    //                     const model = new Post(obj);
    //                     model.autocompleteLabel = model.title;

    //                     data.push(model);
    //                 }

    //                 return data;
    //             })
    //         );
    // }

    async getAppId(): Promise<string | null> {
        return environment.app.id;
        // return this.api
        //     .get('apps')
        //     .stream('up')
        //     .module(AwareHttpRequestModule.Broadcast)
        //     .execute()
        //     .pipe(
        //         take(1),
        //         map((result) => (result.data.length > 0 ? result.data[0].app_id : null))
        //     )
        //     .toPromise();
    }

    saveWeek(weekPost: WeekPost, formData: any, useFileInsteadOfContent = false): AwareHttpRequest {
        weekPost.content = useFileInsteadOfContent
            ? null
            : JSON.stringify(
                  formData.days.reduce((acc, curr) => {
                      acc[curr.day] = curr.content;

                      return acc;
                  }, weekPost.days),
              );

        weekPost.start_at = moment().year(formData.year).week(formData.week).add(2, 'days').format('YYYY-MM-DD');

        weekPost.client_id = formData.client_id;

        const awarePost = new Post({
            uuid: weekPost.uuid,
            title: weekPost.title,
            content: weekPost.content,
            start_at: weekPost.start_at,
            type: weekPost.type,
        });

        let request = awarePost.save(this.api, { fields: ['title', 'content', 'start_at', 'type'] });

        if (useFileInsteadOfContent) {
            const awareFiles = weekPost.media?.length ? weekPost.media.map((m) => new File(m)) : [];
            const [attach, detach] = this.getAttachAndDetachRequests(
                '{{ post.uuid }}',
                'files',
                awareFiles,
                [formData.file],
                null,
                'posts',
            );
            if (detach) {
                request.addSubRequest(detach);
            }
            if (attach) {
                request.addSubRequest(attach);
            }
        }

        // NOTE: Add this back in when deep links are working in the app
        if (!weekPost.uuid) {
            const unit = this.store.selectSnapshot(UnitState.activeUnit);
            const units = !formData.units.length ? [unit.uuid] : formData.units;
            const pushRequest = this.api
                .post('push', {
                    message: awarePost.title,
                    action: awarePost.type,
                    action_id: '{{ post.uuid }}',
                    units: units,
                    roles: ['anhorig'],
                })
                .header('app', environment.api.app)
                .stream('down')
                .module(AwareHttpRequestModule.Broadcast);

            request.addSubRequest(pushRequest);
        }

        if (!formData.units.length) {
            return this.api.batchRequests({ post: request });
        }

        request = request.unit(formData.units[0]);

        let remainingUnits = [...formData.units];
        remainingUnits.shift();
        remainingUnits = formData.units.map((uuid) => new Unit({ uuid }));
        const [attachUnits, detachUnits] = this.getAttachAndDetachRequests('{{ post.uuid }}', 'units', [], remainingUnits, null, 'posts');

        if (detachUnits) {
            request.addSubRequest(detachUnits);
        }
        if (attachUnits) {
            request.addSubRequest(attachUnits);
        }

        return this.api.batchRequests({ post: request });
    }

    show<T = Post>(uuid: string): AwareHttpRequest<T> {
        return this.api.show(this.model.model.route, uuid).toModel(this.model.model);
    }

    buildNotificationFromPost(values): Notification {
        const unit = this.store.selectSnapshot(UnitState.activeUnit);

        return new Notification({
            message: values.title,
            action: values.type,
            action_id: '{{ post.uuid }}',
            topic: { unit: unit.uuid },
        });
    }

    buildNotification(title: string, message: string, action: string, action_id: string, topic: {}): Notification {
        return new Notification({
            title,
            message,
            action,
            action_id,
            topic,
        });
    }

    uploadFilesToPost(files: FileBridgeLocalFile[], postId: string): Observable<void> {
        const formData = new FormData();
        formData.append('post', postId);
        for (const file of files) {
            formData.append('files[]', file.file);
        }

        return this.api.upload(formData, 'files').module(AwareHttpRequestModule.Media).execute();
    }
}
